import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import {
  useMediaQuery,
  Grid2 as Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  List,
  colors
} from '@mui/material';
import { IconAlternate, SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  listItemAvatar: {
    marginRight: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
  },
  listItemText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    margin: 0,
    height: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
}));

const HowItWorks = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title="Simple Onboarding"
        subtitle="How it Works"
      />
      <Grid container spacing={isMd ? 2 : 1}>
        {data.map((item, index) => (
          <Grid size={{ xs: 12, md: 4 }}>
            {/* <Box key={index} padding={{ xs: 1, md: 2, lg: 3 }}> */}
            <Box
              display={'block'}
              width={1}
              height={1}
              sx={{
                textDecoration: 'none',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  transform: `translateY(-${theme.spacing(1 / 2)})`,
                },
              }}
            >
              <Box
                component={Card}
                width={1}
                height={1}
                display={'flex'}
                flexDirection={'column'}
                sx={{ backgroundImage: 'none' }}
              >
                <CardMedia
                  title={item.title}
                  image={item.media}
                  sx={{
                    position: 'relative',
                    height: { xs: 240, sm: 340, md: 280 },
                    overflow: 'hidden',
                  }}
                >
                  <Box
                    component={'svg'}
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 1921 273"
                    sx={{
                      position: 'absolute',
                      width: '100%',
                      left: 0,
                      bottom: 0,
                      right: 0,
                      zIndex: 1,
                    }}
                  >
                    <polygon
                      fill={theme.palette.background.paper}
                      points="0,273 1921,273 1921,0 "
                    />
                    {/* Text inside the polygon */}
                    <text
                      x="90%"                      // Adjust to position on the right
                      y="80%"                      // Adjust to position towards the bottom
                      fill={theme.palette.text.primary}
                      fontSize="72"                // Adjust font size as needed
                      fontWeight="700"
                      textAnchor="end"             // Align text to the right
                      dominantBaseline="middle"

                    >
                      {item.label}
                    </text>


                  </Box>
                </CardMedia>
                <CardContent>
                  <Typography
                    variant={'h6'}
                    gutterBottom
                    align={'left'}
                    sx={{ fontWeight: 700 }}
                  >
                    {item.title}
                  </Typography>
                  <List disablePadding>
                    {item.list.map((item1, index) => (
                      <ListItem disableGutters key={index} data-aos="fade-up">
                        <ListItemAvatar className={classes.listItemAvatar}>
                          <IconAlternate
                            size="extraSmall"
                            fontIconClass="fas fa-check"
                            color={colors.indigo}
                            className={classes.icon}
                          />
                        </ListItemAvatar>
                        <ListItemText className={classes.listItemText} primary={item1} />
                      </ListItem>
                    ))}
                  </List>
                  <Typography
                    variant={'subtitle2'}
                    gutterBottom
                    align={'left'}
                    sx={{
                      fontStyle: 'italic',
                      color: 'primary.main',
                    }}
                  >
                    {item.conclusion}
                  </Typography>

                </CardContent>
                <Box flexGrow={1} />
                {/* <CardActions sx={{ justifyContent: 'flex-end' }}>
                <Button>Learn more</Button>
              </CardActions> */}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

HowItWorks.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default HowItWorks;
